import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css';
import SEO from '../../components/SEO/SEO';

import seoImage from '../../images/seo.jpg';
import paidAdsImage from '../../images/paidads.jpg';

const servicesData = [
    {
        id: 'seo',
        icon: '🔍',
        title: 'SEO Optimization',
        shortDesc: 'Dominate search results with our proven SEO strategies.',
        description: 'Our comprehensive SEO services help you rank higher in search engines, drive organic traffic, and increase your online visibility. We use data-driven strategies and white-hat techniques to deliver sustainable results.',
        features: [
            'Technical SEO Audits',
            'On-Page Optimization',
            'Keyword Research & Strategy',
            'Link Building & Digital PR',
            'Local SEO & Google My Business',
            'E-commerce SEO',
            'Content Strategy & Optimization',
            'Competitor Analysis'
        ],
        pricing: 'Starting at $1,500/month',
        image: seoImage
    },
    {
        id: 'ppc',
        icon: '📈',
        title: 'PPC & Google Ads',
        shortDesc: 'Get instant visibility with targeted advertising campaigns.',
        description: 'Maximize your ROI with expertly managed PPC campaigns. We create, optimize, and manage advertising campaigns across Google Ads, Bing Ads, and other platforms to drive qualified traffic and conversions.',
        features: [
            'Google Ads Management',
            'Search & Display Campaigns',
            'Shopping Ads for E-commerce',
            'Remarketing & Retargeting',
            'Landing Page Optimization',
            'A/B Testing & Optimization',
            'Conversion Tracking Setup',
            'Monthly Performance Reports'
        ],
        pricing: 'Starting at $1,200/month + ad spend',
        image: paidAdsImage
    },
    {
        id: 'web-dev',
        icon: '💻',
        title: 'Web Development',
        shortDesc: 'High-performance websites built for conversions.',
        description: 'We design and develop stunning, fast, and conversion-optimized websites that engage users and drive business growth. From custom websites to e-commerce platforms, we create digital experiences that deliver results.',
        features: [
            'Custom Website Design & Development',
            'E-commerce Development',
            'WordPress Development',
            'Responsive & Mobile-First Design',
            'Website Speed Optimization',
            'CMS Integration',
            'Website Maintenance & Support',
            'SSL & Security Implementation'
        ],
        pricing: 'Starting at $5,000'
    },
    // {
    //     id: 'social-media',
    //     icon: '📱',
    //     title: 'Social Media Marketing',
    //     shortDesc: 'Build your brand across all social platforms.',
    //     description: 'Engage your audience and build a strong social media presence. We create strategic content, manage your social profiles, and run targeted campaigns to grow your brand and drive engagement.',
    //     features: [
    //         'Social Media Strategy',
    //         'Content Creation & Curation',
    //         'Facebook & Instagram Ads',
    //         'LinkedIn Marketing for B2B',
    //         'Community Management',
    //         'Influencer Marketing',
    //         'Social Media Analytics',
    //         'Brand Reputation Management'
    //     ],
    //     pricing: 'Starting at $1,000/month'
    // },
    {
        id: 'email',
        icon: '✉️',
        title: 'Email Marketing',
        shortDesc: 'Nurture leads and drive conversions with email.',
        description: 'Build lasting relationships with your customers through strategic email marketing. We create personalized campaigns that deliver the right message at the right time to maximize engagement and conversions.',
        features: [
            'Email Campaign Strategy',
            'Email Template Design',
            'List Segmentation & Management',
            'Marketing Automation',
            'A/B Testing',
            'Newsletter Creation',
            'Drip Campaigns',
            'Performance Analytics'
        ],
        pricing: 'Starting at $800/month'
    },
    {
        id: 'analytics',
        icon: '📊',
        title: 'Analytics & Reporting',
        shortDesc: 'Data-driven insights to optimize performance.',
        description: 'Make informed decisions with comprehensive analytics and reporting. We track, measure, and analyze your marketing performance to identify opportunities and optimize your campaigns for better results.',
        features: [
            'Google Analytics Setup & Configuration',
            'Custom Dashboard Creation',
            'Conversion Tracking',
            'Multi-Channel Attribution',
            'ROI Analysis',
            'Competitor Benchmarking',
            'Custom Reporting',
            'Data Visualization'
        ],
        pricing: 'Starting at $600/month'
    }
];

const Services = () => {
    return (
        <div className="services-page">
            <SEO
                title="Our Services"
                description="Explore Digi Network's comprehensive digital marketing services: SEO, PPC, Web Development, and Email Marketing designed and optimized for sales."
                canonical="/services"
            />
            {/* Hero Section */}
            <section className="services-hero">
                <div className="services-hero-bg"></div>
                <div className="container">
                    <div className="services-hero-content">
                        <div className="label">Our Services</div>
                        <h1>Comprehensive Digital Marketing Solutions</h1>
                        <p>We offer a full suite of digital marketing services designed to help your business grow online. From SEO to paid advertising, web development to social media, we have the expertise to deliver results.</p>
                    </div>
                </div>
            </section>

            {/* Services Grid */}
            <section className="services-list">
                <div className="container">
                    {servicesData.map((service, index) => (
                        <div className="service-detail" key={service.id} id={service.id}>
                            <div className="service-detail-content">
                                <div className="service-detail-header">
                                    <div className="service-detail-icon">{service.icon}</div>
                                    <div>
                                        <h2>{service.title}</h2>
                                        <p className="service-detail-short">{service.shortDesc}</p>
                                    </div>
                                </div>

                                <div className="service-detail-body">
                                    <div className="service-detail-info">
                                        <p className="service-description">{service.description}</p>

                                        <h3>What's Included:</h3>
                                        <ul className="service-features">
                                            {service.features.map((feature, idx) => (
                                                <li key={idx}>{feature}</li>
                                            ))}
                                        </ul>

                                        <div className="service-pricing">
                                            <span className="pricing-label">Investment:</span>
                                            <span className="pricing-value">{service.pricing}</span>
                                        </div>

                                        <Link to="/contact" className="btn btn-primary">
                                            Get Started
                                            <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white" />
                                            </svg>
                                        </Link>
                                    </div>

                                    <div className="service-detail-visual">
                                        {service.image ? (
                                            <img src={service.image} alt={service.title} className="service-detail-image" />
                                        ) : (
                                            <div className="service-image-placeholder">
                                                <p>🖼️ Add Service Image</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* CTA Section */}
            <section className="services-cta">
                <div className="container">
                    <h2>Ready to Boost Your Digital Presence?</h2>
                    <p>Let's discuss which services are right for your business</p>
                    <Link to="/contact" className="btn btn-primary">
                        Schedule a Free Consultation
                        <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white" />
                        </svg>
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default Services;
